import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ITuple } from '@app/_models/tuple';
import { Inventory } from '@app/_models/_DTOs/inventory';
import { InventoryService } from '@app/_services/inventory.service';
import { NzMessageService } from 'ng-zorro-antd';

@Component({
    selector: 'app-inventory-list',
    templateUrl: './inventory-list.component.html',
    styleUrls: ['./inventory-list.component.css']
})
export class InventoryListComponent implements OnInit {

    constructor(
        private router: Router,
        private messageService: NzMessageService,
        private inventoryService: InventoryService,
        private route: ActivatedRoute
    ) {
    }

    createInventory() {
        this.router.navigate(['create-inventory']);
    }

    level: number = 0;

    pageIndex = 1;
    pageSize = 10;
    total = 1;
    inventoryList: Inventory[] = [];
    loading = true;

    selectedInventory: Inventory;

    loadingDropdowns = false;

    nameSearchValue = "";

    ngOnInit() {
        this.searchData();
        this.route.queryParams.subscribe(params => {
            let inventoryId = params['id'];
            if (inventoryId != undefined) {
                this.openDetailsById(inventoryId);
            }
        });
    }

    searchData(reset: boolean = false): void {
        if (reset) {
            this.pageIndex = 1;
        }
        var filters = "";
        if (this.nameSearchValue.length > 0) {
            filters += "Name@=" + this.nameSearchValue + ",";
        }
        this.loading = true;
        this.inventoryService
            .getPage(this.pageIndex, this.pageSize, "-Created", filters)
            .subscribe((data: ITuple<Inventory>) => {
                this.loading = false;
                this.total = data.item2;
                this.inventoryList = data.item1;
            });
    }

    reset(): void {
        this.nameSearchValue = '';
        this.searchData(true);
    }

    openDetails(inventory: Inventory) {
        this.inventoryService
            .get(inventory.id)
            .subscribe((data: Inventory) => {
                this.selectedInventory = data;
            });
    }

    openDetailsById(inventoryId: number) {
        this.inventoryService
            .get(inventoryId)
            .subscribe((data: Inventory) => {
                this.selectedInventory = data;
            });
    }

    closeDetails() {
        this.selectedInventory = null;
    }

    editInventory(inventory: Inventory) {
        this.router.navigate(['create-inventory'], { queryParams: { id: inventory.id } });
    }

    deleteInventory(id: number) {
        this.inventoryService.delete(id).subscribe(result => {
            this.messageService.create("success", "Inventura uspješno obrisana");
            this.searchData();
        }, error => {
            console.log(error);
        });
    }
}